class FormatacaoUtils {
  static formatarCPF(valor) {
    valor = valor.replace(/\D/g, "");
    valor = valor.slice(0, 11);
    if (valor.length <= 3) return valor;
    if (valor.length <= 6) return valor.replace(/(\d{3})(\d+)/, "$1.$2");
    if (valor.length <= 9) return valor.replace(/(\d{3})(\d{3})(\d+)/, "$1.$2.$3");
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
  }

  static formatarCNPJ(valor) {
    valor = valor.replace(/\D/g, "");
    valor = valor.slice(0, 14);
    if (valor.length <= 2) return valor;
    if (valor.length <= 5) return valor.replace(/(\d{2})(\d+)/, "$1.$2");
    if (valor.length <= 8) return valor.replace(/(\d{2})(\d{3})(\d+)/, "$1.$2.$3");
    if (valor.length <= 12) return valor.replace(/(\d{2})(\d{3})(\d{3})(\d+)/, "$1.$2.$3/$4");
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/, "$1.$2.$3/$4-$5");
  }

  static formatarDocumento(valor) {
    valor = valor.replace(/\D/g, "");
    // Limita a 14 dígitos (máximo para CNPJ)
    valor = valor.slice(0, 14);
    
    // Determina se é CPF ou CNPJ com base no comprimento
    if (valor.length <= 11) {
      return this.formatarCPF(valor);
    } else {
      return this.formatarCNPJ(valor);
    }
  }

  static formatarData(valor) {
    if (!valor) return '';
    // Remove tudo que não for número
    let v = valor.replace(/\D/g, '');
    if (v.length > 8) v = v.slice(0, 8);
    if (v.length > 4) {
      return v.replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3').replace(/\/$/, '');
    } else if (v.length > 2) {
      return v.replace(/(\d{2})(\d{0,2})/, '$1/$2');
    }
    return v;
  }

  static formatarDataParaYYYYMMDD(valor) {
    if (!valor) return null;
    if (valor instanceof Date) {
      const y = valor.getFullYear();
      const m = String(valor.getMonth() + 1).padStart(2, '0');
      const d = String(valor.getDate()).padStart(2, '0');
      return `${y}${m}${d}`;
    }
    // Se vier como string 'dd/MM/yyyy'
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
      const [d, m, y] = valor.split('/');
      return `${y}${m}${d}`;
    }
    // Se vier como string 'yyyy-MM-dd'
    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      return valor.replace(/-/g, '');
    }
    // Se vier como string 'yyyyMMdd' ou 'ddMMyyyy'
    if (/^\d{8}$/.test(valor)) {
      const mes = valor.slice(4, 6);
      if (parseInt(mes, 10) > 12) {
        return `${valor.slice(4,8)}${valor.slice(2,4)}${valor.slice(0,2)}`;
      }
      return valor;
    }
    return null;
  }

  static formatarPorTipo(tipo, valor) {
    switch (tipo) {
      case 'CPF':
        return this.formatarCPF(valor);
      case 'CNPJ':
        return this.formatarCNPJ(valor);
      case 'DOCUMENTO':
        return this.formatarDocumento(valor);
      case 'NUMERO':
        // Remove todos os caracteres não numéricos
        return valor.replace(/\D/g, '');
      case 'DATA':
        return this.formatarData(valor);
      default:
        return valor;
    }
  }   

  // Adiciona utilitário para limpar documento (CPF/CNPJ)
  static limparDocumento(valor) {
    return valor ? valor.replace(/\D/g, "") : "";
  }

  // Adiciona utilitário para limpar número
  static limparNumero(valor) {
    return valor ? valor.replace(/\D/g, "") : "";
  }
}

/**
 * Converte uma string de data ddMMyyyy ou yyyy-MM-dd para objeto Date
 * @param {string} dataStr
 * @returns {Date|null}
 */
export function parseDataString(dataStr) {
  if (!dataStr) return null;
  if (/^\d{8}$/.test(dataStr)) {
    // Formato ddMMyyyy
    const dia = dataStr.substring(0,2);
    const mes = dataStr.substring(2,4);
    const ano = dataStr.substring(4,8);
    return new Date(`${ano}-${mes}-${dia}`);
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataStr)) {
    // Formato dd/MM/yyyy
    const [dia, mes, ano] = dataStr.split('/');
    return new Date(`${ano}-${mes}-${dia}`);
  }
  // Tenta converter normalmente
  const data = new Date(dataStr);
  return isNaN(data.getTime()) ? null : data;
}

 export const TipoFormatacao = {
    CPF: 'CPF',
    CNPJ: 'CNPJ',
    DOCUMENTO: 'DOCUMENTO',
    NUMERO: 'NUMERO',
    DATA: 'DATA',
 };

export default FormatacaoUtils;
